import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Jobs from "./pages/Jobs";
import JobSeekerForm from "./pages/JobSeekerForm";
import HiringForm from "./pages/HiringForm";
import EpisodesManagerServer from "./pages/EpisodesManagerServer"; // 

export default function App() {
  return (
    <div className="app">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sobre-nosotros" element={<About />} />
        <Route path="/contactos" element={<Contact />} />
        <Route path="/empleo" element={<Jobs />} />
        <Route path="/empleo/busca" element={<JobSeekerForm />} />
        <Route path="/empleo/contratando" element={<HiringForm />} />
        <Route path="/episodios/nuevo" element={<EpisodesManagerServer />} />
      </Routes>
      <Footer />
    </div>
  );
}
